/**
 * @fileoverview Defines the configuration interface and utility types for the persistence system.
 *
 * This file contains the `PersistenceConfig` interface for configuring the behavior
 * of the draft persistence system, such as TTL and cleanup intervals. It also
 * includes utility types for defining entity types and storage operations.
 */

import { InjectionToken } from '@angular/core';

/**
 * Defines the configuration options for the draft persistence system.
 */
export interface PersistenceConfig {
	/** The time-to-live (TTL) for stored drafts, in seconds. */
	ttl: number;

	/** The interval (in milliseconds) at which the cleanup service should run. */
	cleanupInterval: number;

	/** The threshold (in milliseconds) for considering a session stale. */
	staleThreshold: number;

	/** The storage quota (in bytes) at which the system should trigger cleanup. */
	storageQuota: number;

	/** Defines if there should be a toast message on loading draft from the storage */
	showToastOnLoad: boolean;
}

export const DRAFT_PERSISTANT_CONFIG = new InjectionToken<PersistenceConfig>('DRAFT_PERSISTANT_CONFIG');
